import { createVanIconComponent } from "./van"

const SettingOutlined = createVanIconComponent("setting-o")
export default SettingOutlined
